import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { IoIosLogOut, IoMdNotificationsOutline } from "react-icons/io";
import { FaAngleDown } from "react-icons/fa6";
import { HiBars3BottomLeft } from "react-icons/hi2";
import { IoCloseCircleOutline } from "react-icons/io5";

import Img1 from '../../assets/img/userProf_pic.png';
import { logout } from '../../actions/auth';
import { LuSquareUser } from 'react-icons/lu';
import { BsHeadset } from 'react-icons/bs';
import { FiCopy, FiCheck, FiChevronRight } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import './TopNav.css';

function TopNav({ title, userDetails, toggleSidebar }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [copiedAccount, setCopiedAccount] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);

  const handleCopyAccount = (e) => {
    e.stopPropagation();
    const accNum = userDetails?.bank_account?.[0]?.account_number;
    if (accNum) {
      navigator.clipboard.writeText(accNum);
      setCopiedAccount(true);
      toast.success("Account ID copied to clipboard!");
      setTimeout(() => setCopiedAccount(false), 2000);
    }
  };

  const fullName =
    userDetails?.account_type === "personal"
      ? `${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`.trim() || "User"
      : userDetails?.business?.name || "Business User";

  const accountNumber = userDetails?.bank_account?.[0]?.account_number;
  const bankName = userDetails?.bank_account?.[0]?.bank_name;
  const isTier2 = Boolean(
    userDetails?.kyc_tier_two_profile &&
    userDetails?.kyc_tier_two_profile?.status !== "rejected"
  );

  const handleOpenSupportChat = () => {
    if (window.Tawk_API) {
      if (userDetails && typeof window.Tawk_API.setAttributes === 'function') {
        window.Tawk_API.setAttributes({
          name: userDetails.full_name || (userDetails.first_name ? `${userDetails.first_name} ${userDetails.last_name}` : 'User'),
          email: userDetails.email || '',
        }, function() {});
      }
      if (typeof window.Tawk_API.maximize === 'function') {
        window.Tawk_API.maximize();
        return;
      }
    }
    toast.info("Connecting to live chat support...", {
      toastId: "tawk-connect-toast",
      autoClose: 2000,
    });
  };

  const handleLogout = async () => {
      
    const token = localStorage.getItem('token');
    // const email = localStorage.getItem('userEmail'); 

    if (!token) {
      // console.error("User credentials missing!");
      return;
    }

    // const credentials = { token, email };

    try {
        await logout(token, navigate, dispatch);
    } catch (error) {
        // console.error("Logout failed:", error.message);
    }
  };

  //click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  
  return (
    <nav className='dash__top__nav__section sticky-top' style={{ backgroundColor: '#F7FCFF' }}>
      <div className="dash__top__nav mb-3 pt-3">
        <div className="dash__top__nav__left d-flex align-items-center gap-3">
          <span className='sidebar-toggle' role='button' onClick={toggleSidebar}><HiBars3BottomLeft className='icon__size' /></span>
          <h2 className='welcome__text mb-0' dangerouslySetInnerHTML={{ __html: title }} ></h2>
          {/* <h2 className='welcome__text mb-0'>Welcome, <span className='welcome__span__text'>Ezekiel!</span></h2> */}
        </div>
        <div className="dash__top__nav__right d-flex align-items-center gap-3">
          <p className="mb-0  d-none d-lg-block">{userDetails?.account_type === "personal" ? userDetails?.first_name + " " + userDetails?.last_name : userDetails?.business?.name}</p>
          
          {/* Tawk.to Live Support Headset with HELP badge */}
          <button
            type="button"
            onClick={handleOpenSupportChat}
            className="btn p-0 border-0 bg-transparent position-relative d-inline-flex align-items-center justify-content-center me-1"
            title="Chat with Support"
            aria-label="Chat with Support"
            style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
          >
            <BsHeadset size={23} style={{ color: '#19064B' }} />
            <span
              className="position-absolute badge rounded-pill"
              style={{
                top: '-8px',
                right: '-11px',
                backgroundColor: '#FFE2EC',
                color: '#FF2E74',
                fontSize: '9px',
                fontWeight: '800',
                padding: '2px 5px',
                letterSpacing: '0.5px',
                boxShadow: '0 1px 3px rgba(255, 46, 116, 0.25)',
                lineHeight: 1,
              }}
            >
              HELP
            </span>
          </button>

          <IoMdNotificationsOutline color='#0A95FF' className='icon__size' />
          {/* Modern Profile Dropdown */}
          <div className="profile-dropdown-wrapper" ref={dropdownRef}>
            <button
              type="button"
              onClick={toggleDropdown}
              className={`profile-trigger-btn ${open ? 'active' : ''}`}
              aria-label="User Profile Menu"
              aria-expanded={open}
            >
              <div className="profile-trigger-avatar-container">
                <img
                  src={userDetails?.avatar || Img1}
                  alt={fullName}
                  className="profile-trigger-avatar"
                />
              </div>
              <div className="d-lg-flex align-items-center d-none">
                <FaAngleDown
                  className={`profile-trigger-chevron ${open ? 'open' : ''}`}
                />
              </div>
            </button>

            {open && (
              <div className="profile-menu-card">
                {/* User Info Header Card */}
                <div className="profile-card-header">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={userDetails?.avatar || Img1}
                      alt={fullName}
                      className="profile-card-avatar"
                    />
                    <div className="d-flex flex-column overflow-hidden text-start">
                      <h6 className="mb-0 fw-bold text-dark text-truncate" style={{ fontSize: '15px' }}>
                        {fullName}
                      </h6>
                      <span className="text-muted text-truncate" style={{ fontSize: '12px' }}>
                        {userDetails?.email || "Account Holder"}
                      </span>
                      <div className="mt-1">
                        {isTier2 ? (
                          <span
                            className="badge rounded-pill"
                            style={{
                              background: '#ECFDF5',
                              color: '#059669',
                              border: '1px solid #A7F3D0',
                              fontSize: '10px',
                              fontWeight: 600,
                              padding: '2px 8px',
                            }}
                          >
                            Tier 2 Verified
                          </span>
                        ) : (
                          <span
                            className="badge rounded-pill"
                            style={{
                              background: '#EFF6FF',
                              color: '#2563EB',
                              border: '1px solid #BFDBFE',
                              fontSize: '10px',
                              fontWeight: 600,
                              padding: '2px 8px',
                            }}
                          >
                            {userDetails?.account_type === "business" ? "Business Account" : "Personal Account"}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Virtual Account Box */}
                  {accountNumber && (
                    <div className="profile-card-account-pill">
                      <div className="d-flex flex-column text-start">
                        <span style={{ fontSize: '10px', color: '#64748B', fontWeight: 700, letterSpacing: '0.5px' }}>
                          {/* bankName ? bankName.toUpperCase() : "VIRTUAL ACCOUNT" */}
                          USER ID
                        </span>
                        <span style={{ fontSize: '13px', fontWeight: 700, color: '#0A95FF', letterSpacing: '0.5px' }}>
                          {accountNumber}
                        </span>
                      </div>
                      <button
                        type="button"
                        onClick={handleCopyAccount}
                        className="profile-copy-btn"
                        title="Copy Account Number"
                      >
                        {copiedAccount ? (
                          <>
                            <FiCheck size={14} color="#10B981" />
                            <span style={{ color: '#10B981', fontWeight: 600 }}>Copied</span>
                          </>
                        ) : (
                          <>
                            <FiCopy size={13} />
                            <span>Copy</span>
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>

                {/* Dropdown Menu Items */}
                <div className="profile-menu-items">
                  <Link
                    to="/user/settings"
                    className="profile-menu-item"
                    onClick={() => setOpen(false)}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="profile-menu-item-icon" style={{ background: '#EFF6FF', color: '#0A95FF' }}>
                        <LuSquareUser size={19} />
                      </div>
                      <div className="d-flex flex-column text-start">
                        <span style={{ fontSize: '14px', fontWeight: 600 }}>Account</span>
                        <span className="text-muted" style={{ fontSize: '11px' }}>Profile & settings</span>
                      </div>
                    </div>
                    <FiChevronRight size={16} className="item-arrow" />
                  </Link>

                  <Link
                    to="/user/admin_support"
                    className="profile-menu-item"
                    onClick={() => setOpen(false)}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="profile-menu-item-icon" style={{ background: '#FAF5FF', color: '#9333EA' }}>
                        <BsHeadset size={18} />
                      </div>
                      <div className="d-flex flex-column text-start">
                        <span style={{ fontSize: '14px', fontWeight: 600 }}>Contact Us</span>
                        <span className="text-muted" style={{ fontSize: '11px' }}>Support, chat & tickets</span>
                      </div>
                    </div>
                    <FiChevronRight size={16} className="item-arrow" />
                  </Link>

                  <div className="profile-menu-divider" />

                  <button
                    type="button"
                    className="profile-menu-item logout-item"
                    onClick={() => {
                      setOpen(false);
                      handleLogout();
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="profile-menu-item-icon" style={{ background: '#FEF2F2', color: '#EF4444' }}>
                        <IoIosLogOut size={20} />
                      </div>
                      <div className="d-flex flex-column text-start">
                        <span style={{ fontSize: '14px', fontWeight: 600 }}>Logout</span>
                        <span style={{ fontSize: '11px', opacity: 0.85 }}>Sign out of session</span>
                      </div>
                    </div>
                    <FiChevronRight size={16} className="item-arrow" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr style={{ width: "98%", margin: "auto"}} />
    </nav>
  )
}

export default TopNav